import React from 'react'
import { DeviceType, PreviewLayout } from 'src/components/ui-customization/preview-layout/PreviewLayout'
import { CartPreview } from './CartPreview'
import { CartControls } from './CartControls'
import { CartLayoutProvider, useCartLayoutContext } from 'src/lib/contexts/CartLayoutContext'
import SaveNotification from '../common/SaveNotification'
import { useCartContext } from 'src/lib/contexts/CartContext'

const CartLayoutContent = () => {
  const {
    actions: { setSelectedElement }
  } = useCartLayoutContext()

  return (
    <PreviewLayout>
      <PreviewLayout.Preview
        viewType={DeviceType.MOBILE}
        onBackgroundClick={() => setSelectedElement(null)}
        title='Core Setup'
      >
        <CartPreview />
      </PreviewLayout.Preview>
      <PreviewLayout.Setup>
        <CartControls />
      </PreviewLayout.Setup>
    </PreviewLayout>
  )
}

export const CartLayoutV2 = () => {
  const {
    getters: { hasUnsavedCartUIChanges, hasUnsavedCartWidgetChanges },
    actions: { discardCartUIChanges, saveCartUIConfigData, discardChanges }
  } = useCartContext()

  return (
    <>
      <CartLayoutProvider>
        <CartLayoutContent />
      </CartLayoutProvider>
      <SaveNotification
        isVisible={hasUnsavedCartUIChanges || hasUnsavedCartWidgetChanges}
        onSave={saveCartUIConfigData}
        onDiscard={() => {
          discardCartUIChanges()
          discardChanges()
        }}
        className='w-full'
      />
    </>
  )
}
